// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__2zIkp","modalFooterButton":"ModalNotes_modalFooterButton__5xpAe"};